import { GameSummaryProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSummaryProperties";
export class SummaryLandscapeProperties extends GameSummaryProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.position.set(973, 466);
        this.scale.set(0.73);
    }
}
//# sourceMappingURL=SummaryLandscapeProperties.js.map